module.exports = __webpack_public_path__ + "static/media/goblins_level.854e13ff.svg";